module.exports = __webpack_public_path__ + "assets/loading.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/loading.gif
 ** module id = 140
 ** module chunks = 1
 **/